/**
 * CardAction3 시나리오
 * 접근성 높은 인터페이스 - action3.svg
 */

import { ReactComponent as Action3SVG } from "@/assets/animations/action3.svg";
import type { MotionScenario } from "../types";

export const cardAction3Scenario: MotionScenario = {
  svgComponent: Action3SVG,

  transitionSpeed: 1500,

  repeat: {
    mode: "infinite", // 무한 반복
  },

  viewBoxAnimation: {
    duration: 800,
    easing: "easeInOut",
  },

  scenes: [
    // Scene 0: action0만 표시
    {
      id: 0,
      name: "action0",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 0,
        },
      ],
      viewBox: {
        x: 0,
        y: 0,
        width: 960,
        height: 540,
     },
      
    },

    // Scene 1: action1만 표시
    {
      id: 1,
      name: "action1",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
      ],
      viewBox: {
        x: 0,
        y: 0,
        width: 960,
        height: 540,
     },
    },
  ],
};
